import React, { useState, useEffect, useContext, useRef, forwardRef, useImperativeHandle } from 'react'
import _ from 'lodash'
import { ListGroup, ListGroupItem } from 'reactstrap';
import LoadingOverlay from "react-loading-overlay"
import { useTranslation } from 'react-i18next'
import {
   Input,
   InputGroupAddon,
   InputGroupText,
   InputGroup,
} from "reactstrap";

import { UserContext } from "context/auth";

import useFetchStatus from 'customHooks/useFetchStatus'
import Modal from 'main_views/components/Modal'
import FormGenerator from './fromGenerator'
import Alert from "main_views/components/alert"
import { successToast, errorToast } from 'main_views/components/toast'
import ticketData from './ticketData'
import { addDoc, getImageUrl, updateDoc } from 'dbHandler'
import { getTicketStep } from 'main_views/Tasks/handler'
import priorityAndDateFields, { staffsDropdown } from 'main_views/form/priorityAndDateFields'
import { handleTicket } from "main_views/Tasks/handler"
import i18n from 'utils/translation/i18n'
import getUserForms from '../getUserForms'

// dsplay a list of the request in a modal
let Requests = forwardRef((props, ref) => {

   let { t } = useTranslation()
   let formGeneratorRef = useRef()

   let { user: currentUser } = useContext(UserContext)

   let [forms, formsError, formsIsLoading] = useFetchStatus(`forms`, {}, [])
   let [gateway, gatewayError, gatewayIsLoading] = useFetchStatus(`gateway`, {}, [])
   let [staffs, staffsError, isStaffsLoading] = useFetchStatus(`staff`, {}, [], null)

   let [staffUrl, setStaffUrl] = useState('')
   let staffQuery = {
      field: 'permissons.CanTakeAction',
      value: true
   }
   let [staff, staffError, staffIsLoading] = useFetchStatus(staffUrl, {}, [staffUrl], staffQuery)

   let [allRequestsList, setAllRequestsList] = useState([])
   let [searchInput, setSearchInput] = useState("")
   let [searchResult, setSearchResult] = useState([])

   let [showReqListModal, setShowReqListModal] = useState(false)
   let [selectedForm, setSelectedForm] = useState()
   let [isSaving, setIsSaving] = useState(false)
   let [alert, setAlert] = useState(null)

   // set the staff list options
   useEffect(() => {
      if (!selectedForm?.margeWithStaffRedirectList || staffIsLoading) return

      let staffList = []
      let { id: currentUserId } = currentUser

      _.forEach(staff, member => {
         if (member.id === currentUserId) return // skip the current user

         staffList.push({ value: member.id, label: member.name_en })
      })

      staffsDropdown.options = staffList
      selectedForm.data = _.concat(selectedForm.data, [staffsDropdown])


   }, [selectedForm, staff])

   // to get the staff list >> only if the user has a permissons to RedirectRequest
   useEffect(() => {
      if (currentUser.permissons?.CanRedirectRequest)
         setStaffUrl('staff')

   }, [currentUser.permissons])

   // set the request list (gatewayList) based on staff role & department
   useEffect(() => {
      if (formsIsLoading || gatewayIsLoading) return

      let gatewayList = getUserForms(gateway, currentUser, forms);

      setAllRequestsList(gatewayList)

   }, [gateway])

   // update search list
   useEffect(() => {
      if (!searchInput) return

      let result = _.filter(allRequestsList, req =>
         _.includes(_.lowerCase(forms[req.formId].name), _.lowerCase(searchInput))
      )

      setSearchResult(result)

   }, [searchInput])

   useImperativeHandle(ref, () => ({
      // calls from parents
      toggleModal() {
         setShowReqListModal(true)
      }

   }))

   let setSelectedFormData = (form, getwayId) => {

      // show priority & due date at the end of each form (only if it not an answer form)
      if (!props.isAnswerForm) {
         let canSetPriority = _.get(currentUser, 'permissons.CanSetPriority', false)

         form.data = _.concat(form.data, _.drop(priorityAndDateFields, !canSetPriority))
      }

      // show Redirect drop menu (if has a permission & this is not an answer form)
      let margeWithStaffRedirectList = (!props.isAnswerForm && _.get(currentUser, 'permissons.CanRedirectRequest', false))

      setSelectedForm({
         ..._.cloneDeep(form),
         getwayId,
         margeWithStaffRedirectList,
      })

   }

   let discardFormChanges = () => {
      setAlert({
         show: true,
         isWarning: true,
         title: t('confirm_discard_changes'),
         msg: t('are_you_sure_you_want_to_discard_all_changes'),
         confirmBtnText: t('yes_discard_changes'),
         cancelBtnText: t('cancel'),
         showCancelBtn: true,
         handelCancel: () => setAlert(null),
         handelConfirm: () => {
            setAlert(null)
            setSelectedForm(null)
         },
      })
   }

   let sendTicket = async () => {

      setIsSaving(true)

      try {

         let { formData, isValid } = formGeneratorRef.current.getData()

         if (!isValid)
            return errorToast(t('please_complete_the_form'))

         if (props.isAnswerForm) {
            props.setAnswerFormData(_.values(formData))
            clearUI()
            return
         }

         ticketData.openedAt = window.fsTimestamp
         ticketData.formId = _.get(selectedForm, 'id')
         ticketData.getwayId = _.get(selectedForm, 'getwayId')
         ticketData.form.data = _.values(formData)
         ticketData.form.name = _.get(selectedForm, 'name')
         ticketData.reminderDays = _.get(selectedForm, 'reminderDays')

         ticketData.requestedBy = currentUser.id
         ticketData.requesterName = currentUser.name_en

         ticketData.priority = _.get(formData, 'priority.value', '')
         ticketData.dueDate = _.get(formData, 'dueDate.value', '')

         // re-directed staffs ids
         ticketData.directedStaffs = _.map(_.get(formData, 'directedStaffs.value'), 'value', [])

         if (!_.isEmpty(ticketData.directedStaffs)) {
            // push the current user id at the end of directedStaffs list
            let { id: currentUserId } = currentUser
            ticketData.directedStaffs.push(currentUserId)
         }

         let db = window.firebaseFirestore
         let ticketsCurrentCounter = await db.doc('counter/tickets').get()

         // set the ticket number based on the tickets Counter
         ticketsCurrentCounter = ticketsCurrentCounter.data().counter
         ticketsCurrentCounter++
         ticketData.number = ticketsCurrentCounter

         await handleTicket(ticketData, true) // to add getwayIds to the ticket
         let ticketNumber = (ticketsCurrentCounter).toLocaleString('en-US', { minimumIntegerDigits: 6, useGrouping: false }) // set the ticket number in 6 digits

         ticketData.number = ticketNumber
         await getTicketStep(ticketData, _.values(staffs))
         console.log("sendTicket -> ticketData", ticketData)

         let increment = window.firebaseIncrement

         // save the data & update the counter
         let [doc, counter] = await Promise.all([
            addDoc(ticketData, `tickets`),
            updateDoc({ counter: increment }, 'counter/tickets')
         ])

         // save the ticket files
         let pfInput = document.querySelector('#files')?.files ?? []
         let files = Array.prototype.slice.call(pfInput)

         if (!_.isEmpty(files)) {

            let url = `tickets/${doc.id}`

            // Array of "Promises"
            let urls = await Promise.all(
               files.map(file => getImageUrl(file, `${url}/${file.name}`))
            )

            let filesUrls = _.map(urls, (url, idx) => ({
               name: files[idx].name,
               url: url
            }))

            await updateDoc({ filesUrls }, url)

         }

         successToast(t('request_was_send'))

         clearUI()

      } catch (error) {
         console.log("sendTicket -> error", error)

         errorToast(t('something_wrong'))

      } finally {

         setIsSaving(false)
      }

   }

   let clearUI = () => {
      if (!props.isAnswerForm)
         props.updateTicketsList()

      setSearchInput('')
      setSelectedForm(null)
      setShowReqListModal(false)
   }

   return (
      <>

         {/* Requests list modal */}
         <Modal
            isOpen={showReqListModal}
            toggle={() => setShowReqListModal(false)}
            title={t(props.isAnswerForm ? 'the_forms' : 'requests')}
            removeBodyPaddings={true}
         >

            <div style={{ minHeight: '50vh', display: 'grid' }}>

               <LoadingOverlay
                  spinner
                  active={formsIsLoading || gatewayIsLoading}
                  text={t('loading')}
                  styles={{
                     overlay: (base) => ({
                        ...base,
                        background: '#fff',
                        color: '#000'
                     }),
                     spinner: (base) => ({
                        ...base,
                        // width: 'px',
                        '& svg circle': {
                           stroke: '#000'
                        }
                     })
                  }}
               >

                  {/* Search input */}
                  <SearchInput handelChanges={setSearchInput} value={searchInput} />

                  <hr className='m-0' />

                  {/* display only the form that has an assigned gateway */}
                  <ListGroup flush={true}>
                     <ListGroupItem disabled tag="button" action>{t('select_a_request')}</ListGroupItem>

                     {_.map(searchInput ? searchResult : allRequestsList, (req) => (

                        <ListGroupItem
                           action
                           key={req.id}
                           tag="button"
                           onClick={() => setSelectedFormData(forms[req.formId], req.id)}
                        >
                           {_.get(forms[req.formId], 'name', '')}
                        </ListGroupItem>

                     ))}

                  </ListGroup>

               </LoadingOverlay>
            </div>

         </Modal>

         {/* specific request form modal */}
         <Modal
            isOpen={!_.isEmpty(selectedForm)}
            toggle={discardFormChanges}
            title={`${_.get(selectedForm, 'name')}`}
            removeBodyPaddings={true}
            hasFooter={true}
            isSaving={isSaving}
            onSave={sendTicket}
            saveText={t(props.isAnswerForm ? 'add' : 'request')}
         >

            <div style={{ minHeight: '50vh', display: 'grid' }}>

               <FormGenerator
                  form={selectedForm}
                  ref={formGeneratorRef}
               />

            </div>

            <Alert {...alert} />
         </Modal>


      </>
   )
})

export default Requests

let SearchInput = ({ handelChanges, value }) =>
   <InputGroup className='m-0 px-3'>

      <Input
         placeholder={i18n.t('search')}
         type="text"
         className='border-0'
         onChange={(e) => handelChanges(e.target.value)}
         value={value}
      />

      {value && (
         <span onClick={() => handelChanges("")}>
            <i className="nc-icon nc-simple-remove"></i>
         </span>
      )}

      <InputGroupAddon addonType='append'>
         <InputGroupText className='border-0'>
            <i className="nc-icon nc-zoom-split" />
         </InputGroupText>
      </InputGroupAddon>

   </InputGroup>


